var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.02679 10.0537H13.4961L8.48532 15.1956C8.08487 15.6065 8.08487 16.2809 8.48532 16.6918C8.88577 17.1027 9.53265 17.1027 9.9331 16.6918L16.6997 9.74811C17.1001 9.33718 17.1001 8.67336 16.6997 8.26243L9.94337 1.3082C9.54292 0.897267 8.89604 0.897267 8.49559 1.3082C8.09514 1.71913 8.09514 2.38294 8.49559 2.79388L13.4961 7.94633H2.02679C1.46206 7.94633 1 8.42048 1 9C1 9.57952 1.46206 10.0537 2.02679 10.0537Z","fill":"white","stroke":"white","strokeWidth":"0.5"}));
}

Arrow.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
